// Copyright (c) 2022 by Move Closer

import { VueConstructor } from 'vue'

import { htmlVideoDriver } from './partials/HTMLVideo/HTMLVideo.helpers'
import { youtubeVideoDriver } from './partials/YoutubeVideo/YouTubeVideo.helpers'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum VideoDriverVersion {
  YouTube = 'youtube',
  Video = 'video'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface VideoDriver {
  /**
   * Defines whehther current driver is applicable with given source.
   */
  checkForUse(source: string): boolean

  /**
   * Driver's component.
   */
  component: VueConstructor
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const videoDriverRegistry: Record<VideoDriverVersion, VideoDriver> = {
  [VideoDriverVersion.YouTube]: youtubeVideoDriver,
  [VideoDriverVersion.Video]: htmlVideoDriver
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum PlayerRatio {
  '1-1' = '1-1',
  '4-3' = '4-3',
  '16-9' = '16-9'
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const availableRatioMap: Record<string, string> = {
  [PlayerRatio['1-1']]: '1-1',
  [PlayerRatio['4-3']]: '4-3',
  [PlayerRatio['16-9']]: '16-9'
}
